module.exports = __webpack_public_path__ + "static/media/ios-checkmark.a9500f2c.svg";